import GracePeriod from './GracePeriod'
import OneTimeOpenOptionJson from './interfaces/OneTimeOpenOptionJson'

export default class OneTimeOpenOption {
  enabled: boolean
  gracePeriodOnFirstOpen: GracePeriod

  constructor(enabled: boolean, gracePeriodOnFirstOpen: GracePeriod) {
    this.enabled = enabled
    this.gracePeriodOnFirstOpen = gracePeriodOnFirstOpen
  }

  static fromJson(data: OneTimeOpenOptionJson) {
    return new this(
      data.enabled,
      GracePeriod.fromJson(data.gracePeriodOnFirstOpen),
    )
  }
}
